import React from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { fetchPolicy } from 'lib/apolloFetchPolicy'

import ControlledModal from 'components/Modal/ControlledModal'
import AdStatusForm from 'components/Ads/AdStatusForm/AdStatusForm'
import Loading from 'components/Util/Loading'

import getVehicleAdStatusModal from 'graphql/view/getVehicleAdStatusModal.gql'

import './ad-status-modal.css'

const AdStatusModal = ({ data, match }) => {
    const { loading, error, vehicle } = data
    const { adStatus } = match.params

    return (
        <ControlledModal
            routedModal
            name="ad-status-modal"
            context="adStatusModal"
            requireUserInput={true}
        >
            {(modalProps) => (
                <Loading loading={loading} error={error}>
                    {() => (
                        <AdStatusForm
                            setTitle={modalProps.setTitle}
                            onCancel={modalProps.closeModal}
                            onSubmitted={modalProps.closeModal}
                            adStatus={adStatus.toUpperCase()}
                            vehicle={vehicle}
                            renderButtonsPortalTarget={modalProps.mobileButtonsDOMElement}
                        />
                    )}
                </Loading>
            )}
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    graphql(getVehicleAdStatusModal, {
        options: ({ match, currentUser }) => ({
            variables: {
                vehicleId: match.params.vehicleId,
            },
            fetchPolicy: fetchPolicy.NETWORK_ONLY,
        })
    }),
)(AdStatusModal)
